import { lazy } from "react";
import { RouteObject } from "react-router-dom";
import { BioMetricGuard } from "../../routes/Guards/BioMetricGuard";
import { R_HomeRoutes } from "../../utils/Routes";
import SuspenseWrapper from "../../components/CustomLazyLoading/CustomLazyLoading";

const Dashboard = lazy(() => import("./Dashboard"));

const HomeRoutes: RouteObject[] = [
  {
    path: R_HomeRoutes.home,
    element: <BioMetricGuard />,
    children: [
      {
        index: true,
        element: <SuspenseWrapper LazyLoadingComponent={Dashboard} />,
      },
    ],
  },
];

export default HomeRoutes;
